import { useEffect } from "react";

const useFocusOnFirstError = (errors, setFocus) => {
  return useEffect(() => {
    const firstErrorKey = Object.keys(errors).find((key) => errors[key]);
    if (firstErrorKey) {
      setFocus(firstErrorKey);
    }
  }, [errors, setFocus]);
};

export default useFocusOnFirstError;
